import CatalogModel from "./catalog";

export default CatalogModel;
